import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';

export interface ConfirmationDialogData {
  title?: string;
  message?: string;
  question?: string;
  cancelLabel?: string;
  confirmLabel?: string;
}

@Component({
  selector: 'via-confirmation-dialog',
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
})
export class ConfirmationDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<ConfirmationDialogComponent, boolean>);
  private readonly dialogData = inject(MAT_DIALOG_DATA, {optional: true}) as ConfirmationDialogData | null;

  get title(): string {
    return this.dialogData?.title ?? 'Confirm';
  }

  get message(): string {
    return this.dialogData?.message ?? 'This action cannot be undone.';
  }

  get question(): string {
    return this.dialogData?.question ?? 'Are you sure?';
  }

  get cancelLabel(): string {
    return this.dialogData?.cancelLabel ?? 'Cancel';
  }

  get confirmLabel(): string {
    return this.dialogData?.confirmLabel ?? 'Confirm';
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
